import { NavigationDrawer } from "@softmax/design-system";
import { colors, spacing } from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";
import type { ReactNode, ReactElement, MouseEventHandler } from "react";
import type {
  SiteNavigationLink,
  SiteNavigationLinkProps,
} from "./site-navigation-types";
import { SiteNavigationAction } from "./site-navigation-action";

export function SiteNavigationMobile({
  mobileOpen,
  setMobileOpen,
  identity,
  account,
  action,
  renderLink,
  onNavigate: closeOnNavigation,
  children,
}: {
  readonly mobileOpen: boolean;
  readonly setMobileOpen: (open: boolean) => void;
  readonly identity: ReactNode;
  readonly account: ReactNode;
  readonly action: SiteNavigationLink | null;
  readonly renderLink: (props: SiteNavigationLinkProps) => ReactElement;
  readonly onNavigate: MouseEventHandler<HTMLAnchorElement>;
  readonly children: ReactNode;
}) {
  return (
    <div {...stylex.props(styles.mobile)}>
      <div {...stylex.props(styles.mobileAction)}>
        {account ?? (
          <SiteNavigationAction action={action} renderLink={renderLink} />
        )}
      </div>
      <NavigationDrawer
        open={mobileOpen}
        onOpenChange={setMobileOpen}
        header={
          <>
            {identity}
            <div {...stylex.props(styles.end)}>
              <div {...stylex.props(styles.mobileAction)}>
                {account ?? (
                  <SiteNavigationAction
                    action={action}
                    renderLink={renderLink}
                    onClick={closeOnNavigation}
                  />
                )}
              </div>
            </div>
          </>
        }
        trigger={
          <button
            type="button"
            aria-label={mobileOpen ? "Close menu" : "Open menu"}
            {...stylex.props(styles.menuTrigger)}
          >
            <span {...stylex.props(styles.hamburgerLine)} />
            <span {...stylex.props(styles.hamburgerLine)} />
            <span {...stylex.props(styles.hamburgerLine)} />
          </button>
        }
      >
        {children}
      </NavigationDrawer>
    </div>
  );
}

const styles = stylex.create({
  end: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    flex: 1,
    minWidth: 0,
  },
  mobile: {
    display: { default: "flex", "@media (min-width: 900px)": "none" },
    alignItems: "center",
    gap: spacing.space12,
  },
  mobileAction: {
    display: { default: "none", "@media (min-width: 380px)": "block" },
  },
  menuTrigger: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: 44,
    height: 44,
    gap: 5,
    borderWidth: 0,
    backgroundColor: "transparent",
    color: colors.foreground,
    cursor: "pointer",
  },
  hamburgerLine: { height: 1.5, width: 18, backgroundColor: colors.foreground },
});
